/**
 * 개발용 토큰 관리 (portal 앱 전용)
 * TODO: 로그인 인증 모듈 구현 후 setAccessToken()을 통해 동적으로 설정
 */

import { setAccessToken, getAccessToken } from '@cnd_fe/ky-client'

// 개발용 고정 토큰 (portal 앱용)
const DEV_TOKEN = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjMyOTlmOWRmLTZhOTMtNDczOC1hNTlhLTIzODM3ZDdmYjdkZiJ9.eyJzdWIiOiJhZG1pbjEiLCJuYW1lIjoi6rSA66as7J6QIiwi bWJyVW5xSWQiOiJNRU1fMDAwMDAwMDAwMDA2MzM0NiIsImF1ZCI6InJlcy1hZG1pbiIsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCJdLCJyb2xlcyI6WyJST0xFX0FETUlOIl0sImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6OTAwMCIsImlhdCI6MTc2NTM2MjkwMiwibmJmIjoxNzY1MzYyOTAyLCJleHAiOjE3NjUzNjM1MDIsImp0aSI6IjUyM2VjYmYxLTc5OWMtNDM4Yy04M2E4LWMzYjZhODk0MDM4MSJ9.ZHVtbXktc2lnbmF0dXJl'

/**
 * 개발용 토큰 초기화
 * 앱 시작 시 호출하여 토큰이 없으면 개발용 토큰으로 자동 설정
 */
export const initializeDevToken = () => {
  if (!getAccessToken()) {
    // setAccessToken(DEV_TOKEN)
  }
}
